import { styled } from '@vw-marketing/us-components';

export const TableInformationContainer: any = styled.div`
  margin-bottom: 35px;
  margin-top: 10px;
`;

export const Table: any = styled.table`
  border-collapse: collapse;
  width: 100%;
`;

export const Tbody: any = styled.tbody`
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
`;

export const Tr: any = styled.tr`
  border: 1px solid #dfe4e8;
`;

export const Td: any = styled.td`
  border: 1px solid #dfe4e8;
  padding: 8px 6px;
`;

export const TdShort: any = styled.td`
  border: 1px solid #dfe4e8;
  padding: 8px 20px;
`;
